import React from 'react'

import * as yup from 'yup'
import { Formik } from 'formik'
import { useNavigate } from 'react-router-dom'

import UIButton from '../../components/UI/UIButton'
import UITextInput from '../../components/UI/UITextInput'
import UIFieldError from '../../components/UI/UIFieldError'
import { Icon } from '../../components/Icon'
import { ReactComponent as LogoSvg } from '../../assets/svgs/logos/Logo.svg'
import { resendVerificationEmail } from '../../api/auth/password'
import { createUser, ErrorResponse } from '../../utils/types'
import { toast } from 'react-toastify'

const validationSchema = yup.object().shape({
  email: yup.string().email().required('Email Address is Required'),
})

const VerifyEmail = () => {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-gray1 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mx-5 sm:mx-auto sm:w-full sm:max-w-lg flex">
        <div className="flex gap-4 flex-1 ">
          <LogoSvg width={130} height={36} />
        </div>
      </div>
      <Formik
        enableReinitialize
        initialValues={{
          email: '',
        }}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          try {
            const response = (await resendVerificationEmail(values.email)) as {
              status?: string
              data: createUser
            }
            if (response?.status == 'successful') {
              toast.success('Sent Email to user.', {
                position: 'top-right',
              })
            } else {
              toast.error('Network Error.', {
                position: 'top-right',
              })
            }
          } catch (error) {
            const errors = error as ErrorResponse
            if (errors.response && errors.response.data) {
              const errorMessage =
                errors.response.data.message || 'An error occurred'
              toast.error(errorMessage, {
                position: 'top-right',
              })
            } else {
              toast.error('An unexpected error occurred', {
                position: 'top-right',
              })
            }
          }
        }}
      >
        {({ handleSubmit, errors, handleChange, values, handleBlur }) => (
          <div className="mx-5 sm:mx-auto mt-8 sm:w-full sm:max-w-lg">
            <div className="bg-white py-10 px-4 shadow rounded-[1rem] sm:px-10">
              <div
                onClick={() => navigate(-1)}
                className="cursor-pointer w-fit"
              >
                <Icon
                  name={'IconArrowNarrowLeft'}
                  width={24}
                  height={24}
                  strokeWidth={1.5}
                  stroke={'#02698C'}
                />
              </div>
              <div className="flex flex-col py-2 gap-3 justify-center items-center text-center mt-7">
                <Icon
                  name="IconCheckVerified"
                  width={52}
                  height={52}
                  strokeWidth={1}
                  stroke={'#02698C'}
                />
                <p className="text-lg font-bold text-text2">
                  Resend verification email
                </p>
                <p className="text-sm font-normal text-text5">
                  Please enter your email. A verification email will be sent
                  there.
                </p>
              </div>
              <div className="mt-8">
                <div className="flex flex-col gap-5">
                  <div>
                    <UITextInput
                      error={errors?.email}
                      label={'Email Address'}
                      value={values.email}
                      onChange={handleChange('email')}
                      onBlur={handleBlur('email')}
                      placeholder="Please enter your email address"
                      iconName={'IconMail'}
                    />
                    {errors.email ? (
                      <UIFieldError
                        className="mt-2"
                        errorMessage={errors.email}
                      />
                    ) : null}
                  </div>
                </div>

                <div className="container mx-auto mt-8">
                  <UIButton label="Send" type="submit" onClick={handleSubmit} />
                </div>
              </div>
            </div>
            <div className="sm:mx-auto w-full h-auto px-8 my-4 py-6 rounded-[1rem] gap-16 bg-gray2">
              <div className="flex gap-3 items-center">
                <Icon
                  name={'IconCheckMonogram'}
                  width={16}
                  height={16}
                  strokeWidth={1}
                />
                <p className="font-medium text-xs text-text5">Privacy Policy</p>
                <p className="font-medium text-xs text-text5">
                  Terms & Conditions
                </p>
              </div>
              <div className="mt-4">
                <p className="font-medium text-xs text-text3">
                  All rights reserved. SCR Solutions is a trading name of
                  Streamlearn Ltd. Company No. 12180453. Registered office: Axis
                  19 Mallard Way, Riverside Business Park, Swansea Vale,
                  Swansea, SA7 0AJ.
                </p>
              </div>
            </div>
          </div>
        )}
      </Formik>
    </div>
  )
}

export default VerifyEmail
